import { useRouter } from "next/router";

const useRouterVariable = <T extends any>(
  variable: string,
  mapper: (a: string | string[] | null) => T = (a) => a as T
) => {
  const router = useRouter();
  return variable ? mapper(router.query[variable]) : null;
};

export default useRouterVariable;
